import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../../mass-upload-form-control.component';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { environment } from 'src/environments/environment';

@FormComponentLookup('mass-upload-grid-control-state')
@Component({
  selector: 'app-mass-upload-state-form-control',
  templateUrl: './mass-upload-state-form-control.component.html',
  styleUrl: '../../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadStateFormControlComponent extends MassUploadFormControlComponent {

  ngOnInit() {
    super.ngOnInit();

    this.selfAsFormControl.addAsyncValidators(this.createAgencyValidator());

    let countyControl = this.getCountyControl();
    this.subscriptionGroup.push(countyControl.valueChanges.subscribe(async (countyName: string) => {
      let county = await this.getCounty();
      if (county){
        this.resetFormValue(county.state);
      }
      else {
        this.resetFormValue(null);
      }
    }));
  }
  
  createAgencyValidator(): AsyncValidatorFn {
    const _this = this;

    return (control: AbstractControl): Promise<ValidationErrors> => {
      return new Promise(async (resolve, reject) => {
        const selectedAgency = this.entitlementsHelperService.getSelectedAgency(LINE_OF_BUSINESS_ENUM.INDIVIDUAL);
        const county = await this.getCounty();

        let stateValue = null;
        /**
         * Multi-brand ASPs compare with their regions
         * Single-brand ASPs comare with their states.
         * 
         * But these values are not always appropriate ( for example, Minnesota's region value is "MINCR" but their state value is "MN" )
         * selectedAgency will use region values, not state values, so single-brand ASPs need to have their region explicitly checked against
         */
        if (county) {
          switch (environment.initData.brand.ASPID) {
            case "MN":
            case "ND":
            case "WY": 
              stateValue = county.region;
              break;
            case "HM": 
              stateValue = county.state;
              break;
          };
        }

        // agency region should actually be the State
        if (stateValue === selectedAgency.region){
          resolve({});
        }
        else {
          resolve({agencyRegion: 'agency does not match state'});
        }
      });
    };
  }
}
